import { createActionGroup, props } from '@ngrx/store';
import { Statistic } from '@main/customers/store/statistic';

export const customerStatisticsApiActions = createActionGroup({
  source: 'CustomerStatisticsAPI',
  events: {
    getStatisticsSuccess: props<{ customerId: number, statistics: Statistic[] }>(),
    getStatisticsFailure: props<{ err: any }>(),
  },
});
